<template>
  <div class="app-wrapper bg-white h-100">
    <div class="app-main">
      <div class="app-content p-0">
        <div class="app-content--inner d-flex align-items-center">
          <div class="flex-grow-1 w-100 d-flex align-items-center">
            <div class="bg-composed-wrapper--content py-5">
              <div class="-fluid">
                <b-modal
                  centered
                  v-model="modalShow"
                  no-close-on-backdrop
                  hide-header-close
                  header-class="d-none"
                  footer-class="border-0 pt-0"
                  body-class="pb-2 pt-4"
                  content-class="shadow-none border-0 p-3"
                  dialog-class="modal-verification"
                >
                  <template v-slot:modal-backdrop>
                    <div class="fck-this-backdrop"></div>
                  </template>
                  <strong style="color : #3F7EA7;font-size:16px;"> 
                    Anda tidak memiliki akses halaman!
                  </strong>
                  <div slot="modal-footer">
                    <b-button @click="redirect" class="btn-back" >
                      {{ "Kembali" }}
                    </b-button>
                  </div>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalShow: false,
    };
  },
  
  methods: {
    toggleModal() {
      this.modalShow = !this.modalShow;
    },
    redirect() {
      this.$router.replace('/');
    }
  },
  mounted() {
    this.toggleModal();
  },
  destroyed() {
    this.toggleModal();
  }
};
</script>

<style lang="scss">
.fck-this-backdrop {
  background-image: url("~@/assets/img/confirm-signup.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: absolute;
}

.modal-verification {
  max-width: 580px;
}

.btn-back {
  color: #fff;
  background-color: rgb(63, 126, 167);
  border-color: rgb(63, 126, 167);
}

.btn-back:hover {
  color: #fff !important;
  background-color: rgb(63, 126, 167) !important;
  border-color: rgb(63, 126, 167) !important;
}
</style>
